import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-minimal-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './minimal-layout.component.html',
  styleUrl: './minimal-layout.component.css',
})
export class MinimalLayoutComponent {}
